import {Injectable} from '@angular/core';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(private _configuration: ConfigurationService) {
    }

    // Confirmations //
    get confirmationAcknowledgeURL(): string {
        return this._configuration.RESTURL + '/confirmation/acknowledge/';
    }

    get confirmationCountURL(): string {
        return this._configuration.RESTURL + '/confirmation/select/count/';
    }

    get confirmationItemsURL(): string {
        return this._configuration.RESTURL + '/confirmation/select/items/';
    }

    // Inventory Receiving //
    get inventoryGetDetailsURL(): string {
        return this._configuration.RESTURL + `/receive/headeranddetails?custId=customerId&status=current_status&trackingId=tracking_Id`;
    }

    get saveReceivingReceipt(): string {
        return this._configuration.RESTURL + `/receive/post/receipt`;
    }

    get downloadBohReceipt(): string {
        return this._configuration.RESTURL + `/receive/bohreceipt?custId=customerId&trackingId=tracking_Id`;
    }

    get downloadFtpReceipt(): string {
        return this._configuration.RESTURL + `/receive/ftpreceipt?custId=customerId&trackingId=tracking_Id`;
    }

    // Items //
    get allItemNumbersURL(): string {
        return this._configuration.RESTURL + `/order/allitems/store_number/tracking_id`;
    }

    // Ordering //
    get orderCreateURL(): string {
        return this._configuration.RESTURL + `/order/create/unsched/`;
    }

    get orderInsertItemURL(): string {
        return this._configuration.RESTURL + `/order/insertitems/`;
    }

    get orderStatusUpdateURL(): string {
        return this._configuration.RESTURL + `/order/status/update?orderNumber=order_number&status=status_status&custId=cust_id`;
    }

    get orderCreateSchedURL(): string {
        return this._configuration.RESTURL + `/order/create/sched/`;
    }

    get orderOpenoOrder(): string {
        return this._configuration.RESTURL + `/order/openorder/`;
    }

    // Order Review //
    get orderReviewConfirmURL(): string {
        return this._configuration.RESTURL + `/reports/order/reviewconfirmed`;
    }

    get orderReviewDetailsURL(): string {
        return this._configuration.RESTURL + `/reports/order/reviewdetails`;
    }

    // Profile Item Category //
    get profileAddCategoryURL(): string {
        return this._configuration.RESTURL + `/profile/add/category?categorydescription=category_description&customerid=customer_number`;
    }

    get profileAddBulkItemCategoryURL(): string {
        return this._configuration.RESTURL + `/profile/add/bulk/itemcategory`;
    }

    get profileDeleteCategoryURL(): string {
        return this._configuration.RESTURL + `/profile/delete/category?categoryid=category_id`;
    }

    get profileItemCategoriesURL(): string {
        return this._configuration.RESTURL + `/profile/select/categories?customerId=customer_number`;
    }

    get profileRemoveBulkItemCategoryURL(): string {
        return this._configuration.RESTURL + `/profile/remove/bulk/itemcategory`;
    }

    // Profile Item Profile //
    get profileBulkItemsURL(): string {
        return this._configuration.RESTURL + `/profile/select/bulk/itemprofile?customerId=customer_number&itemstatus=item_status`;
    }

    get saveProfileItemsURL(): string {
        return this._configuration.RESTURL + `/profile/update/bulk/itemprofile`;
    }

    // Reports //
    get confirmedItemsReportURL(): string {
        return this._configuration.RESTURL + `/reports/select/confirmeditems`;
    }

    get newItemReportURL(): string {
        return this._configuration.RESTURL + `/reports/newitems`;
    }

    // Schedule //
    get callScheduleURL(): string {
        return this._configuration.RESTURL + `/order/select/callschedule/customer_number`;
    }

    // MOG //
    get mogSelectNewGroupURL(): string {
        return this._configuration.RESTURL + `/mog/select/newgroup`;
    }

    get mogUpdateGroupURL(): string {
        return this._configuration.RESTURL + `/mog/update/group/store_number/group_number`;
    }

    get mogSyncOrderGuideURL(): string {
        return this._configuration.RESTURL + `/mog/sync/orderguide/store_number/group_number`;
    }

    // error //
    get splunkErrorURL(): string {
        return this._configuration.RESTURL_CONNECT_SUPPORT + `/util/log`;
    }

    // Stores //
    get storeListURL(): string {
        return this._configuration.RESTURL + `/customer/select/storelist`;
    }

    get invoicesForCustIdURL(): string {
        return this._configuration.RESTURL_OLI + `/invoice/store/chain/customer_number/src_systems`;
    }

    get uploadOrderURL(): string {
        return this._configuration.RESTURL + `/order/uploadorder`;
    }

    get getInvoiceReportURL(): string {
        return this._configuration.RESTURL_OLI + `/invoice/invoicereportview`;
    }

    get getStoreLoginURL():string{
        return this._configuration.RESTURL+ '/uam/logins/customer_number';
    }
    
}
